import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import mindright from '../core/theme/mindright';
import AppRoutes from './routes/AppRoutes';
import AuthRedirectListener from '../core/AuthRedirectListener';
import { GoogleMapsProvider } from '../core/components/ui/address/GoogleMapsProvider';
import { Toaster } from 'react-hot-toast';
import * as FullStory from '@fullstory/browser';
import ScrollToTop from './routes/components/ScrollToTop';

// FullStory.init({ orgId: import.meta.env.VITE_ORG_ID});
FullStory.init({ orgId: 'F3F4F', devMode: false });

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ThemeProvider theme={mindright}>
        <CssBaseline />
        <AuthRedirectListener />
        <GoogleMapsProvider>
          <AppRoutes />
        </GoogleMapsProvider>
        <Toaster />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
